import type { CSSProperties, ReactNode, Ref } from "react";
import type { CardResizeSpec } from "./cardResizeSpec";

interface CardLayoutPreviewProps {
  spec: CardResizeSpec;
  /** Класовете и стилът на решетката в размера, който ще стане при пускане
   *  на дръжката — същите като на истинската. */
  gridClassName: string;
  gridStyle: CSSProperties;
  /** Копия на кутийките (същото съдържание) — по тях решетката се оразмерява
   *  точно както истинската след пускането (дълги имена и т.н.). */
  cards: { key: number; card: ReactNode }[];
  ref?: Ref<HTMLDivElement>;
}

/**
 * Предварителният изглед при влачене на дръжка на кутийка (`CardResizeGrips`):
 * на мястото на истинските кутийки (скрити, но на място — под пръста е
 * дръжката) — кутийките в новия размер с бледо съдържание и сиви пунктирани
 * контури, за да се вижда накъде ще порасне кутийката — настрани (колко на
 * ред) или нагоре/надолу (височината). Същата решетка като истинската,
 * затова при пускане кутийките заемат точно тези контури.
 */
export const CardLayoutPreview = ({ spec, gridClassName, gridStyle, cards, ref }: CardLayoutPreviewProps) => (
  <div
    ref={ref}
    aria-hidden
    className={`pointer-events-none absolute inset-x-0 top-0 ${gridClassName}`}
    style={gridStyle}
  >
    {cards.map(({ key, card }) => (
      <div key={key} className="@container/card relative flex min-w-0">
        {/* Без собствените рамка и фон — контурът е пунктирът отгоре */}
        <div className={`flex min-w-0 flex-1 opacity-50 ${spec.previewContentClassName}`}>{card}</div>
        <span
          className={`absolute inset-0 border-[1.5px] border-dashed border-pos-muted ${spec.previewContourClassName}`}
        />
      </div>
    ))}
  </div>
);
